import { render, staticRenderFns } from "./GaofangShenHe.vue?vue&type=template&id=d54b373c&scoped=true"
import script from "./GaofangShenHe.vue?vue&type=script&lang=js"
export * from "./GaofangShenHe.vue?vue&type=script&lang=js"
import style0 from "./GaofangShenHe.vue?vue&type=style&index=0&id=d54b373c&prod&lang=scss&scoped=true"
import style1 from "./GaofangShenHe.vue?vue&type=style&index=1&id=d54b373c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54b373c",
  null
  
)

export default component.exports